module.exports = __webpack_public_path__ + "img/13.9b3cd4af.jpg";